import React from "react";
import Popup from "reactjs-popup";
const PopupComponent = (props) => {
  return (
    <Popup
      open={props.open}
      className={props.className}
      contentStyle={{
        padding: "1.5rem",
        backgroundColor: "white",
        borderRadius: 4,
        width: props.width ? props.width : 450,
        height: props.height ? props.height : "auto",
        overflowY: "auto",
      }}
      overlayStyle={{
        backgroundColor: "#00000080",
      }}
      closeOnDocumentClick={false}
      closeOnEscape={false}
    >
      {props.children}
    </Popup>
  );
};

export default PopupComponent;
